import { CreateSupportTicketTeamEnum, PriorityEnum, RequestCategoryEnum } from 'api';
import { getOptionsFromEnum } from 'features';

export const priorityOptions = getOptionsFromEnum(PriorityEnum);
export const teamOptions = getOptionsFromEnum(CreateSupportTicketTeamEnum);

// Temporary hardcoded mapping. Ideally, this should come from the backend
//  through the schema.
export const teamRequestCategoryMap: Map<CreateSupportTicketTeamEnum, RequestCategoryEnum[]> = new Map([
  [
    CreateSupportTicketTeamEnum.Compliance,
    [
      RequestCategoryEnum.Company,
      RequestCategoryEnum.Documentation,
      RequestCategoryEnum.Legal_Contract_Review,
      RequestCategoryEnum.Licenses,
      RequestCategoryEnum.PERN,
      RequestCategoryEnum.Regulations,
    ],
  ],
  [
    CreateSupportTicketTeamEnum.Finance,
    [
      RequestCategoryEnum.Credit_Notes,
      RequestCategoryEnum.Debit_Note,
      RequestCategoryEnum.General,
      RequestCategoryEnum.Invoice_Adjustments,
      RequestCategoryEnum.Payments,
      RequestCategoryEnum['Pre-Payments'],
    ],
  ],
  [
    CreateSupportTicketTeamEnum.Logistics,
    [
      RequestCategoryEnum.Buyer_Issues,
      RequestCategoryEnum.Data_Change_Request,
      RequestCategoryEnum.Delivery_Update,
      RequestCategoryEnum.Finance,
      RequestCategoryEnum.Inspections,
      RequestCategoryEnum.Loading_Update,
      RequestCategoryEnum.Supplier_Issues,
      RequestCategoryEnum['Terms_&_Conditions'],
      RequestCategoryEnum.Transport_Issues,
    ],
  ],
  [
    CreateSupportTicketTeamEnum.Product,
    [
      RequestCategoryEnum['Bug/Issue_with_the_System'],
      RequestCategoryEnum.Customer_Product_Support,
      RequestCategoryEnum.Data_Change_Request,
      RequestCategoryEnum.Product_Feature_Request,
    ],
  ],
  [
    CreateSupportTicketTeamEnum.Quality,
    [
      RequestCategoryEnum.Claims,
      RequestCategoryEnum.General,
      RequestCategoryEnum.Discretionary_Inspections,
      RequestCategoryEnum.First_Time_Seller_Inspection,
    ],
  ],
]);
